import React, { memo } from 'react';
import RMModal from 'components/modal/RMModal';
import { ScoreGroupSettings } from './ScoreGroupSettings';
import { FmlxModal } from 'fmlx-common-ui';

interface Props {
  showModal: boolean;
  setShowModal(val: boolean): void;
}
export const ScoreGroupConfigButton = memo((props: Props) => {
  const { showModal, setShowModal } = props;

  return (
    <>
      <RMModal
        id="scoregroup-config-modal"
        showModal={showModal}
        setShowModal={setShowModal}
        body={<ScoreGroupSettings setShowModal={setShowModal}></ScoreGroupSettings>}
        heading="Score Group Configurations"
        showButtons={false}
        size={FmlxModal.Size.LARGE}
      />
    </>
  );
});
